import Trackers from './tracker';

Element.prototype.parents = function(selector) {
    var elements = [];
    var elem = this;
    var ishaveselector = selector !== undefined;

    while ((elem = elem.parentElement) !== null) {
        if (elem.nodeType !== Node.ELEMENT_NODE) {
            continue;
        }

        if (!ishaveselector || elem.matches(selector)) {
            elements.push(elem);
        }
    }

    return elements;
};

export default class Events {
    constructor() {
        this.searchData = [];
    }
    init() {
        let self = this;
        this.onClickSoc();
        this.onClickCity();
        this.onClickSocIcon();
        this.onClickProductTabs();
        this.onClickProductPdf();
        this.onClickPhone();
        this.onClickTabs();
        this.showMainBanner();
        this.showSpecBanner();
        this.onClickMainPromo();
        this.onShowWatched();
        this.onShowAnalog();
        this.onClickProductCatalogBlock();
        this.onClickWatched();
        this.onClickAnalog();
        this.onShowCatalogProducts();

        setTimeout(function() {
            self.onShowNewProducts();
            self.onClickNewProducts();
        }, 1000);
    }

    onClickSoc() {
        $('body').on('click', '.footer__column--social a', function(e) {
            let data = this.dataset;
            let trackers = new Trackers();
            trackers.onClickEvent(data);
        });
    }

    onClickTabs() {
        $('body').on('click', '.tabs__tab--cloud', function(e) {
            let data = this.dataset;
            let trackers = new Trackers();
            trackers.onClickEvent(data);
        });
    }

    onClickPhone() {
        $('body').on('click', '.city-data-block__phones-link', function(e) {
            let trackers = new Trackers();
            trackers.onPMbtnTel();
        });
    }

    onClickProductTabs() {
        $('body').on('click', '.product-card__tabs .tabs__tab', function(e) {
            let data = this.dataset;
            let trackers = new Trackers();
            trackers.onClickEvent(data);
        });
    }

    onClickProductPdf() {
        $('body').on('click', '.product-card__previews-item--pdf', function(e) {
            let data = this.dataset;
            let trackers = new Trackers();
            trackers.onClickPdf(data);
        });
    }

    onClickSocIcon() {
        $('body').on('click', '.bottom-menu__text-contacts-icon', function(e) {
            let data = this.dataset;
            let trackers = new Trackers();
            trackers.onClickEvent(data);
        });
    }

    onClickCity() {
        $('body').on('click', '.cities-list .cities-list__item a', function(e) {
            let data = this.dataset;
            let trackers = new Trackers();
            trackers.onClickEvent({
                event: 'PMbtnSelectCity',
                param: data.code
            });
        });
    }

    /**
     * ловим события баннера на главной странице
     */
    showMainBanner() {
        let localBanners = [];
        let self = this;
        $('.js-slick-fullwidth-slider')
            .on('init', function(event, slick) {
                let activeBanner = document.querySelectorAll('.fullwidth-slider .slick-track .slick-active');
                let bannerId = self.sendItemBanner(localBanners, activeBanner[0].dataset, 'indexTopSlider');
                localBanners.push(bannerId);
            })
            .on('afterChange', function(event, slick, currentSlide, nextSlide) {
                let activeBanner = document.querySelectorAll('.fullwidth-slider .slick-track .slick-active');
                let bannerId = self.sendItemBanner(localBanners, activeBanner[0].dataset, 'indexTopSlider');
                localBanners.push(bannerId);
            });
    }

    showSpecBanner() {
        let localBanners = [];
        let specBanners = document.querySelectorAll('.block-list--promos a.tiles__item--promo');
        let self = this;

        specBanners.forEach(function(element, index) {
            let banner = {
                id: element.dataset.id,
                name: element.dataset.name,

                position: 'slot' + index
            };
            let bannerId = self.sendItemBanner(localBanners, banner, 'indexBannerSpec');
            localBanners.push(bannerId);
        });
    }

    sendItemBanner(localBanners, activeBanner, name) {
        if (activeBanner !== undefined) {
            if (localBanners.indexOf(activeBanner.id) === -1) {
                let trackers = new Trackers();
                trackers.onViewPromo({
                    promoView: {
                        promotions: [
                            {
                                id: activeBanner.id,
                                name: name,
                                creative: activeBanner.name,
                                position: activeBanner.position
                            }
                        ]
                    }
                });
                localBanners.push(activeBanner.id);
                return activeBanner.id;
            }
        }
    }

    onClickMainPromo() {
        $('body').on('click', '.block-list.block-list--promos a', function(e) {
            let dataId = this.getAttribute('data-id');
            let dataName = this.getAttribute('data-name');
            let trackers = new Trackers();
            let dataNumber = 0;
            if (this.parentNode.classList.contains('tiles__item--action-content')) {
                dataNumber = parseInt($(this.parentNode.parentNode).index()) + 1;
            } else {
                dataNumber = parseInt($(this).index()) + 1;
            }
            trackers.onClickPromo({
                promoClick: {
                    promotions: [
                        {
                            id: dataId,
                            name: dataName,
                            creative: 'banner' + dataNumber,
                            position: 'slot' + dataNumber
                        }
                    ]
                }
            });
        });
    }

    onShowNewProducts() {
        let productData = [];
        let self = this;
        let products = document.querySelectorAll('.products-slider .products-slider__item');
        products.forEach(function(item, index) {
            let productsData = self.prepareData(item);
            let product = {
                list: 'newProducts',
                position: index,
                ...productsData
            };

            productData.push(product);
        });

        let trackers = new Trackers();

        if (productData.length > 0) {
            trackers.onShowNewProducts({
                impressions: productData
            });
        }
    }

    onShowWatched() {
        let productData = [];
        let self = this;
        let products = document.querySelectorAll('.also-viewed .grid__item');
        products.forEach(function(item, index) {
            let productsData = self.prepareData(item);
            let product = {
                list: 'WatchedProducts',
                position: index,
                ...productsData
            };

            productData.push(product);
        });

        let trackers = new Trackers();

        if (productData.length > 0) {
            trackers.onShowWatchedProducts({
                impressions: productData
            });
        }
    }

    onShowAnalog() {
        let productData = [];
        let self = this;
        let products = document.querySelectorAll('.site-block .tabs__content .grid__item');
        products.forEach(function(item, index) {
            let productsData = self.prepareData(item);
            let product = {
                list: 'AnalogProducts',
                position: index,
                ...productsData
            };

            productData.push(product);
        });

        let trackers = new Trackers();

        if (productData.length > 0) {
            trackers.onShowAnalogProducts({
                impressions: productData
            });
        }
    }

    /**
     * отображение каталога, отправляем пачками по 8 элементов. Когда появляется 1ый из группы
     */
    onShowCatalogProducts() {
        let products = [];
        let productNodes = document.querySelectorAll('.catalog #catalog__products .grid__item');
        let self = this;

        productNodes.forEach(function(item, index) {
            if (index % 8 === 0) {
                new Waypoint.Inview({
                    element: item,
                    enter: function() {
                        if (products.indexOf(index) === -1) {
                            let productsArr = Array.prototype.slice.call(productNodes).slice(index, index + 8);
                            let productsList = [];

                            products.push(index);

                            productsArr.forEach(function(elem, i) {
                                let productData = self.prepareData(elem);
                                productsList.push({
                                    list: 'catalogProducts',
                                    position: index + i + 1,
                                    ...productData
                                });
                            });
                            let trackers = new Trackers();

                            if (productsList.length > 0) {
                                trackers.onShowcatalogProducts({
                                    impressions: productsList
                                });
                            }
                        }
                    }
                });
            }
        });
    }

    /**
     * отображение каталога в поиске, отправляем пачками по 10 элементов. Когда появляется 1ый из группы
     */
    onShowSearchProducts() {
        let productNodes = document.querySelectorAll('.search_container #catalog__products .grid__item');
        let self = this;

        productNodes.forEach(function(item, index) {
            if (index % 10 === 0) {
                new Waypoint.Inview({
                    element: item,
                    enter: function() {
                        if (self.searchData.indexOf(index) === -1) {
                            let productsArr = Array.prototype.slice.call(productNodes).slice(index, index + 10);
                            let productsList = [];

                            self.searchData.push(index);

                            productsArr.forEach(function(elem, i) {
                                let productData = self.prepareData(elem);
                                productsList.push({
                                    list: 'searchProducts',
                                    position: index + i + 1,
                                    ...productData
                                });
                            });
                            let trackers = new Trackers();

                            if (productsList.length > 0) {
                                trackers.onShowcatalogProducts({
                                    impressions: productsList
                                });
                            }
                        }
                    }
                });
            }
        });
    }

    onClickProductCatalogBlock() {
        let self = this;

        $('.grid.catalog .product').on('click', 'a', function() {
            let productDom = $(this).parents('.product')[0];
            let productData = self.prepareData(productDom);
            let position = $($(this).parents('.grid__item')[0]).index('#catalog__products .grid__item') + 1;
            let product = {
                position: position,
                ...productData
            };
            localStorage.setItem('list', 'catalogProducts');
            let trackers = new Trackers();
            trackers.onClickCatalogProducts({
                click: {
                    actionField: {
                        list: 'catalogProducts'
                    }
                },
                products: [product]
            });
        });
    }

    onClickProductSearchBlock() {
        let self = this;
        $('.search_container .grid .product').on('click', 'a', function() {
            let productDom = $(this).parents('.product')[0];
            let productData = self.prepareData(productDom);
            let position = $($(this).parents('.grid__item')[0]).index('#catalog__products .grid__item') + 1;
            let product = {
                list: 'searchProducts',
                position: position,
                ...productData
            };
            localStorage.setItem('list', 'searchProducts');
            let trackers = new Trackers();
            trackers.onClickCatalogProducts({
                click: {
                    actionField: {
                        list: 'searchProducts'
                    }
                },
                products: [product]
            });
        });
    }

    onClickWatched() {
        let self = this;
        $('.also-viewed.grid .product').on('click', 'a, img', function() {
            let productDom = $(this).parents('.product')[0];
            let productData = self.prepareData(productDom);
            let position = $($(this).parents('.grid__item')[0]).index('.also-viewed .grid__item') + 1;
            let product = {
                list: 'WatchedProducts',
                position: position,
                ...productData
            };
            localStorage.setItem('list', 'WatchedProducts');
            let trackers = new Trackers();
            trackers.onClickWatched({
                click: {
                    actionField: {
                        list: 'WatchedProducts'
                    }
                },
                products: [product]
            });
        });
    }

    onClickAnalog() {
        let self = this;
        $('.site-block .tabs__content .grid__item .product').on('click', 'a', function() {
            let productDom = $(this).parents('.product')[0];
            let productData = self.prepareData(productDom);
            let position = $($(this).parents('.grid__item')[0]).index('.site-block .tabs__content .grid__item') + 1;
            let product = {
                list: 'AnalogProducts',
                position: position,
                ...productData
            };
            localStorage.setItem('list', 'AnalogProducts');
            let trackers = new Trackers();
            trackers.onClickAnalog({
                click: {
                    actionField: {
                        list: 'AnalogProducts'
                    }
                },
                products: [product]
            });
        });
    }

    onClickNewProducts() {
        let self = this;
        $('.products-slider .products-slider__item .product').on('click', 'a', function() {
            let productDom = $(this).parents('.product')[0];
            let productData = self.prepareData(productDom);
            let position =
                $($(this).parents('.products-slider__item')[0]).index('.products-slider .products-slider__item') + 1;
            let product = {
                list: 'newProducts',
                position: position,
                ...productData
            };
            localStorage.setItem('list', 'newProducts');
            let trackers = new Trackers();
            trackers.onClickNewProducts({
                click: {
                    actionField: {
                        list: 'newProducts'
                    }
                },
                products: [product]
            });
        });
    }

    onShowProductCard() {
        let self = this;
        if ($('.product-card').length > 0) {
            let productDom = $('.product-card')[0];
            let productData = self.prepareData(productDom);
            let product = {
                ...productData
            };

            let trackers = new Trackers();
            trackers.onShowProductCard({
                detail: {
                    actionField: {
                        list: localStorage.getItem('list')
                    }
                },
                products: [product]
            });
        }
    }

    onShowProductCardPopup() {
        let self = this;
        let productDom = $('.product-card')[0];
        let productData = self.prepareData(productDom);
        let product = {
            ...productData
        };

        let trackers = new Trackers();
        trackers.onShowProductCardPopup({
            detail: {
                actionField: {
                    list: localStorage.getItem('list')
                }
            },
            products: [product]
        });
    }

    onAddToCardProduct(elem) {
        //проверяем откуда клик на добавление в корзину (карточка, списки)
        if (elem.hasClass('product-card__btn')) {
            this.addToCardFromCard(elem);
        } else {
            this.addToCardFromList(elem);
        }
    }

    addToCardFromCard(elem) {
        let self = this;
        let productDom = elem.parents('.product-card')[0];
        let productData = self.prepareData(productDom);
        let product = {
            quantity: 1,
            ...productData
        };
        let trackers = new Trackers();
        trackers.addToCardFromCard({
            add: {
                products: [product]
            }
        });
    }

    addToCardFromList(elem) {
        let self = this;
        let productDom = elem.parents('.product')[0];
        let position = 0;
        let list = '';
        let productData = self.prepareData(productDom);

        if (elem.parents('.catalog #catalog__products').length > 0) {
            list = 'catalogProducts';
            position = $(elem.parents('.grid__item')).index('#catalog__products .grid__item') + 1;
        } else if (elem.parents('.slick-track').length > 0) {
            list = 'newProducts';
            position = $(elem.parents('.products-slider__item')).index('.slick-track .products-slider__item') + 1;
        } else if (elem.parents('div[data-tab="analogs"]').length > 0) {
            list = 'AnalogProducts';
            position = $(elem.parents('.grid__item')).index('div[data-tab="analogs"] .grid__item') + 1;
        } else if (elem.parents('.also-viewed').length > 0) {
            list = 'WatchedProducts';
            position = $(elem.parents('.grid__item')).index('.also-viewed .grid__item') + 1;
        } else if (elem.parents('.search_container').length > 0) {
            list = 'searchProducts';
            position = $(elem.parents('.grid__item')).index('.search_container .grid__item') + 1;
        }
        let trackers = new Trackers();

        let product = {
            list: list,
            position: position,
            ...productData
        };

        trackers.onClickCatalogProducts({
            click: {
                actionField: {
                    list: list
                }
            },
            products: [product]
        });

        product = {
            ...productData
        };

        trackers.onShowProductCard({
            detail: {
                actionField: {
                    list: list
                }
            },
            products: [product]
        });

        product = {
            quantity: 1,
            ...productData
        };

        trackers.addToCardFromList({
            add: {
                products: [product]
            }
        });
    }

    onClickCartAddProduct(dataProductId, quantityOld, quantityChange) {
        let product = document.querySelectorAll('div[data-product-id="' + dataProductId + '"]');

        let productData = [];
        let trackers = new Trackers();

        let dataName = product[0].getAttribute('data-product-name');
        let dataPrice = product[0].getAttribute('data-product-price');
        let dataBrand = product[0].getAttribute('data-product-brand');
        let dataCategory = product[0].getAttribute('data-product-category');

        let products = {
            name: dataName,
            id: dataProductId,
            price: dataPrice,
            brand: dataBrand,
            category: dataCategory,
            quantity: quantityChange - quantityOld
        };

        productData.push(products);

        if (productData.length > 0) {
            trackers.onClickAddProduct({
                add: {
                    products: productData
                }
            });
        }
    }

    onClickCartRemoveProduct(dataProductId, quantityOld, quantityChange) {
        let product = document.querySelectorAll('div[data-product-id="' + dataProductId + '"]');

        let productData = [];
        let trackers = new Trackers();

        let dataName = product[0].getAttribute('data-product-name');
        let dataPrice = product[0].getAttribute('data-product-price');
        let dataBrand = product[0].getAttribute('data-product-brand');
        let dataCategory = product[0].getAttribute('data-product-category');

        let products = {
            name: dataName,
            id: dataProductId,
            price: dataPrice,
            brand: dataBrand,
            category: dataCategory,
            quantity: quantityOld - quantityChange
        };

        productData.push(products);

        if (productData.length > 0) {
            trackers.onClickRemoveProduct({
                remove: productData
            });
        }
    }

    onShowOrderCartStep1(data) {
        let productData = [];
        let trackers = new Trackers();

        for (let productItem in data.PRODUCTS) {
            let item = data.PRODUCTS[productItem];

            let product = {
                name: item.NAME,
                id: item.ID,
                price: item.PRICE,
                brand: data.BRANDS[item.PROPERTY_BREND_VALUE],
                category: item.CATEGORY,
                quantity: item.QUANTITY
            };
            productData.push(product);
        }
        if (productData.length > 0) {
            trackers.onShowOrderCartStep1({
                checkout: {
                    actionField: {
                        step: 1
                    },
                    products: productData
                }
            });
        }
    }

    /**
     * подгоовка данных
     * @param elem
     * @returns {{price: number, name: string, category: number, brand: number}}
     */
    prepareData(elem) {
        let name = '';
        if (
            elem.querySelector('[data-name]') !== null &&
            elem.querySelector('[data-name]').dataset.name !== undefined
        ) {
            name = elem.querySelector('[data-name]').dataset.name;
        }

        let productId = '';
        if (
            elem.querySelector('[data-product-id]') !== null &&
            elem.querySelector('[data-product-id]').dataset.productId !== undefined
        ) {
            productId = elem.querySelector('[data-product-id]').dataset.productId;
        }

        let price = 0;
        if (
            elem.querySelector('[data-price]') !== null &&
            elem.querySelector('[data-price]').dataset.price !== undefined
        ) {
            price = elem.querySelector('[data-price]').dataset.price;
        }

        let brand = 0;
        if (
            elem.querySelector('[data-brand]') !== null &&
            elem.querySelector('[data-brand]').dataset.brand !== undefined
        ) {
            brand = elem.querySelector('[data-brand]').dataset.brand;
        }

        let category = 0;
        if (
            elem.querySelector('[data-category]') !== null &&
            elem.querySelector('[data-category]').dataset.category !== undefined
        ) {
            category = elem.querySelector('[data-category]').dataset.category;
        }

        return {
            name: name,
            price: price,
            brand: brand,
            category: category,
            id: productId
        };
        for (let productItem in data.PRODUCTS) {
            let item = data.PRODUCTS[productItem];

            let product = {
                name: item.NAME,
                id: item.ID,
                price: item.PRICE,
                brand: data.BRANDS[item.PROPERTY_BREND_VALUE],
                category: item.CATEGORY,
                quantity: item.QUANTITY
            };
            productData.push(product);
        }
        if (productData.length > 0) {
            trackers.onShowOrderCartStep1({
                checkout: {
                    actionField: {
                        step: 1
                    },
                    products: productData
                }
            });
        }
    }

    onShowOrderStep(param) {
        let step = 1;
        if (param) {
            step = param;
        }
        let productData = [];
        let trackers = new Trackers();

        let products = document.querySelectorAll('.cart .cart__item.basket__cart__item.cart__item--checkout');
        products.forEach(function(item, index) {
            let name = '';
            if (
                item.getAttribute('data-product-name') !== null &&
                item.getAttribute('data-product-name') !== undefined
            ) {
                name = item.getAttribute('data-product-name');
            }

            let price = 0;
            if (
                item.getAttribute('data-product-price') !== null &&
                item.getAttribute('data-product-price') !== undefined
            ) {
                price = item.getAttribute('data-product-price');
            }

            let brand = 0;
            if (
                item.getAttribute('data-product-brand') !== null &&
                item.getAttribute('data-product-brand') !== undefined
            ) {
                brand = item.getAttribute('data-product-brand');
            }

            let category = 0;
            if (
                item.getAttribute('data-product-category') !== null &&
                item.getAttribute('data-product-category') !== undefined
            ) {
                category = item.getAttribute('data-product-category');
            }

            let quantity = 0;
            if (
                item.querySelectorAll('.quantity__value')[0].value !== null &&
                item.querySelectorAll('.quantity__value')[0].value !== undefined
            ) {
                quantity = item.querySelectorAll('.quantity__value')[0].value;
            }

            let product = {
                name: name,
                id: item.getAttribute('data-product-id'),
                price: price,
                brand: brand,
                category: category,
                quantity: quantity
            };

            productData.push(product);
        });

        if (productData.length > 0) {
            trackers.onShowOrderStep({
                checkout: {
                    actionField: {
                        step: step
                    },
                    products: productData
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./blocks/tracker/events.js